module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [(!_vm.$root.isCustomer) ? _c('row', [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [(_vm.$root.isAdmin) ? _c('va-small-box', {
    attrs: {
      "color": "aqua",
      "icon": "ion-bag",
      "title": _vm.$root.dashData.TotalDealers ? _vm.$root.dashData.TotalDealers : 0,
      "description": "Dealers",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Dealers')
      }
    }
  }) : (_vm.$root.isDealer || _vm.$root.isDealerAssistance) ? _c('va-small-box', {
    attrs: {
      "color": "aqua",
      "icon": "ion-bag",
      "title": _vm.$root.dashData.TotalCustomers ? _vm.$root.dashData.TotalCustomers : 0,
      "description": "Customers",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Customers')
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "green",
      "icon": "ion-stats-bars",
      "title": _vm.$root.dashData.TotalSites ? _vm.$root.dashData.TotalSites : 0,
      "description": "Sites",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Sites')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "yellow",
      "icon": "ion-printer",
      "title": _vm.$root.dashData.TotalPrinters ? _vm.$root.dashData.TotalPrinters : 0,
      "description": "Printers",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('AllPrinters')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "red",
      "icon": "ion-person",
      "title": _vm.$root.dashData.TotalUsers ? _vm.$root.dashData.TotalUsers : 0,
      "description": "Users",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Users')
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.isCustomer) ? _c('row', [_c('div', {
    staticClass: "col-lg-4 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "aqua",
      "icon": "ion-user",
      "title": "Welcome",
      "description": _vm.userFullName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "green",
      "icon": "ion-printer",
      "title": _vm.$root.dashData.TotalPrinters ? _vm.$root.dashData.TotalPrinters : 0,
      "description": "Printers",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Printers')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-xs-6"
  }, [_c('va-small-box', {
    attrs: {
      "color": "yellow",
      "icon": "ion-stats-bars",
      "title": _vm.$root.dashData.TotalSites ? _vm.$root.dashData.TotalSites : 0,
      "description": "Sites",
      "moreText": "More info"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Sites')
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Recent System Alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "chart"
  }, [_c('VueTable', {
    ref: "vueTableAlerts",
    attrs: {
      "guid": _vm.guidAlerts,
      "isPaging": false,
      "info": _vm.infoIcons,
      "columns": _vm.alertsColumns,
      "rows": _vm.$root.dashData.recentAlerts
    },
    on: {
      "rowClick": _vm.rowClick
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersStatus')
      }
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Printers Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersOnline')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Online")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOnline : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    style: ({
      width: _vm.$root.dashData.PrintersStatusPercent.TotalOnline
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersOffline')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Offline")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOffline : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    style: ({
      width: _vm.$root.dashData.PrintersStatusPercent.TotalOffline
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersOutOfPaper')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Out of Paper")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOutPaper : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    style: ({
      width: _vm.$root.dashData.PrintersStatusPercent.TotalOutPaper
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersLowToner')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Low Toner")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOutToner : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    style: ({
      width: _vm.$root.dashData.PrintersStatusPercent.TotalOutToner
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersErrors')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Errors")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalError : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    style: ({
      width: _vm.$root.dashData.PrintersStatusPercent.TotalError
    })
  })])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAccounting),
      expression: "showAccounting"
    }],
    staticClass: "box-footer"
  }, [_c('row', [_c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block border-right"
  }, [_c('span', {
    staticClass: "description-percentage text-green"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  }), _vm._v(" 17%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("$35,210.43")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("TOTAL REVENUE")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block border-right"
  }, [_c('span', {
    staticClass: "description-percentage text-yellow"
  }, [_c('i', {
    staticClass: "fa fa-caret-left"
  }), _vm._v(" 0%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("$10,390.90")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("TOTAL COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block border-right"
  }, [_c('span', {
    staticClass: "description-percentage text-green"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  }), _vm._v(" 20%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("$24,813.53")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("TOTAL PROFIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('span', {
    staticClass: "description-percentage text-red"
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  }), _vm._v(" 18%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("1200")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("GOAL COMPLETIONS")])])])])], 1)])]), _vm._v(" "), _c('DownloadInstaller')], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.$root.isLoading,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        return _vm.$set(_vm.$root, "isLoading", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d1764fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 686
// module chunks = 0